<template>
    <div class="wrap">
        <div class="options" tabindex="0" @keydown="doKeyboard($event, true)" role="menu" ref="optionList"
                :aria-label="$t(`${menuname}.ariaName`)">
            <div v-for="(o,ind) in options" :key="ind" :ref="`opt-${ind}`"
                :class="{ disabled: o.disabled, selected: ind === selectIndex, separator: o.separator,
                value: value=== o.value }" class="item"
                @mouseenter="mouseSelect(ind)" @click="clickEntry(ind)" role="menuitem"
                :aria-selected="ind === selectIndex" :aria-label="o.aria">
                <slot v-bind:row="o">
                    <hr v-if="o.separator">
                    <template v-else>
                        <font-awesome-icon v-if="o.type === 'switch'" :icon="o.checked ? 'toggle-on' : 'toggle-off'"
                                size="lg" class="toggle"/>
                        <font-awesome-icon v-if="o.icon" :icon="o.icon"/>
                        <span v-if="o.text">{{o.text}}</span>
                    </template>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'DropMenu',
  components: { FontAwesomeIcon },
  data: function() {
    return {
      selectIndex: 0
    };
  },
  props: {
    // Array of {text:, value:, icon:, aria:, disabled: <bool>}
    options: Array,
    menuname: {
      type: String,
      required: true
    },
    value: String
  },
  mounted() {
    console.log('move Selector mounted');
    this.selectIndex = this.options.findIndex(o => o.selected);
    if (this.selectIndex === -1) {
      this.selectIndex = 0;
    }
    if (this.value) {
      const valueIndex = this.options.findIndex(o => o.value === this.value);
      if (valueIndex !== -1) {
        this.selectIndex = valueIndex;
      }
    }
    this.$nextTick(() => {
      console.log(this.$refs);
      this.$refs['optionList'].focus();
      this.$nextTick(() => {
        console.log('scroll to', this.selectIndex);
        this.$refs[`opt-${this.selectIndex}`][0].scrollIntoView({ behaviour: 'smooth', block: 'nearest' });
      });
    });
  },
  methods: {
    mouseSelect(ind) {
      if ((!this.options[ind].disabled) && (!this.options[ind].separator)) {
        this.selectIndex = ind;
      }
    },
    doKeyboard(evt) {
      console.log('dropmenu key', evt.key);
      const oldSelect = this.selectIndex;
      if (evt.key === 'ArrowDown') {
        this.selectIndex++;
        evt.preventDefault();
      } else if (evt.key === 'ArrowUp') {
        this.selectIndex--;
        evt.preventDefault();
      } else if (evt.key === 'PageDown') {
        this.selectIndex += 10;
      } else if (evt.key === 'PageUp') {
        this.selectIndex -= 10;
      } else if (evt.key === 'Home') {
        this.selectIndex = 0;
      } else if (evt.key === 'End') {
        this.selectIndex = this.options.length - 1;
      } else if (evt.key === 'Escape') {
        this.$emit('hide');
      } else if (((evt.key === 'Enter') || (evt.key === 'Space')) && (this.selectIndex >= 0) &&
        (this.selectIndex < this.options.length)) {
        this.clickEntry(this.selectIndex);
        evt.stopPropagation();
      }
      if (this.selectIndex >= this.options.length) {
        this.selectIndex = this.options.length - 1;
      }
      if (this.selectIndex < 0) {
        this.selectIndex = 0;
      }

      if ((oldSelect !== this.selectIndex) && (this.options.length > 0)) {
        this.$refs[`opt-${this.selectIndex}`][0].scrollIntoView({ behaviour: 'smooth', block: 'nearest' });
      }
    },
    clickEntry(ind) {
      this.$nextTick(() => this.$emit('hide'));
      if (this.options[ind].type === 'switch') {
        this.$emit('check', { name: this.options[ind].value, checked: !this.options[ind].checked });
      } else {
        this.$emit('select', this.options[ind].value);
      }
    }
  },
  computed: {
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';
    .wrap {
        display: inline-block;
        z-index: 100;
        position: absolute;
        top: 20px;
        left: 0px;
        background-color: white;
        color: $black;
        box-shadow: 0px 0px 5px 3px $gray-200;
        max-height: 50vh;
        min-height: 1em;
        max-width: 50vw;
        padding: 0;
        display: flex;
        flex-direction: column;

        .options {
            flex: 1;
            overflow-y: auto;
            overflow-x: auto;

            .item {
                padding: 5px 5px 5px 5px;
                cursor: pointer;
                user-select: none;
                white-space: nowrap;
                &.selected {
                    background-color: $gray-300;
                }
                &.value {
                    background-color: $blue;
                    color: $light;
                }
                &.disabled {
                    color: $gray-500;
                    cursor: inherit;
                }
                &.separator {
                    height: 10px;
                    cursor: inherit;
                    hr {
                        margin-top: 1px;
                        margin-bottom: 1px;
                        border: 0;
                        border-top: 1px solid $gray-400;
                    }
                }
                .toggle {
                    margin-right: 5px;
                }
                .searchHighlight {
                    font-weight: bold;
                }
            }
        }
    }

</style>
